import * as React from "react";
import lowerCase from "lodash/lowerCase";
import { Pluralize, Tooltip } from "components/common";
import useEntityCollectionStatus from "collections/hooks/useEntityCollectionStatus";
import { createGRN } from "logic/permissions/GRN";
import ExpandedSectionCount from "components/common/EntityDataTable/ExpandedSectionCount";
const EntityCollectionCell = ({ entityId, entityType }) => {
  const entityGRN = createGRN(entityType, entityId);
  const { data, isFetching, isError } = useEntityCollectionStatus(entityGRN, entityId);
  const count = (data == null ? void 0 : data.length) || 0;
  if (isFetching || isError) {
    return null;
  }
  if (count === 0) {
    return null;
  }
  const label = /* @__PURE__ */ React.createElement("span", null, "This ", lowerCase(entityType), " is in ", count, " ", /* @__PURE__ */ React.createElement(Pluralize, { value: count, plural: "collections", singular: "collection" }), ".");
  return /* @__PURE__ */ React.createElement(Tooltip, { withArrow: true, position: "right", label }, /* @__PURE__ */ React.createElement(ExpandedSectionCount, { entityId, section: "collections", count, label: "collections" }));
};
export const getCollectionsCustomColumnRenderer = (entityType) => ({
  collections: {
    renderCell: (_collections, entity) => /* @__PURE__ */ React.createElement(EntityCollectionCell, { entityId: entity.id, entityType }),
    staticWidth: "matchHeader",
    textAlign: "right"
  }
});
export default EntityCollectionCell;
